import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import tw, { styled, css } from "twin.macro"

import MitoMicroLogo from "../svgs/mitoMicroLogo"

import Img from "gatsby-image"
import Container from "./container"

interface TopBarProps {
    showEnrolButton?: boolean
    hideEnrolButton?: boolean
    enrolButtonClicked?: () => void
}

const TopBarWrapper = styled.div`
    ${tw`fixed top-0 z-10 w-full p-4 flex flex-row justify-center`},
    ${css`
        background: rgb(0, 0, 0);
        background: linear-gradient(
            0deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 1) 25%,
            rgba(0, 0, 0, 1) 100%
        );
    `}
`

const TopBarContent = styled.div`
    ${tw`flex flex-row justify-between content-center items-center container`}
`

const Title = styled.span`
    font-weight: 750;
    font-size: 0.5rem;
    @media (min-width: 768px) {
        font-size: 0.66rem;
    }
    letter-spacing: 0.165rem;
    ${tw`font-sans text-white uppercase ml-4 whitespace-pre-line md:whitespace-normal`}
`

const LogoContainer = styled.div`
    ${tw`mx-2 md:mx-0`}
`

const Button = styled.button`
    padding: 0.2rem 1.05rem;
    ${tw`font-licenz bg-brand-yellow rounded text-lg text-black tracking-wide uppercase hidden md:inline hover:bg-white hover:text-black focus:outline-none`}
`

const TopBar: React.SFC<TopBarProps> = ({
    hideEnrolButton,
    enrolButtonClicked,
}) => {
    const data = useStaticQuery(query)
    const logoSources = [data.mitoLogo.childImageSharp.fixed]

    const title = "Introduction to\nAutomotive Engineering"
    return (
        <TopBarWrapper>
            <Container>
                <TopBarContent>
                    <div css={[tw`hidden md:inline`]}>
                        <a href="https://mito.org.nz/" target="_blank">
                            <Img
                                css={[
                                    css`
                                        margin-top: -8px;
                                    `,
                                    tw`content-center hidden`,
                                ]}
                                fixed={logoSources}
                            />
                        </a>
                    </div>
                    <div css={[tw`flex flex-row justify-between items-center`]}>
                        <LogoContainer>
                            <MitoMicroLogo aria-label="Mito Micro" />
                        </LogoContainer>
                        <Title>{title}</Title>
                    </div>
                    {/* Enrol Button */}
                    <Button
                        css={[
                            tw`transition-opacity duration-500 hidden md:inline`,
                            hideEnrolButton && tw`opacity-0`,
                        ]}
                        onClick={enrolButtonClicked}
                    >
                        Enrol
                    </Button>
                </TopBarContent>
            </Container>
        </TopBarWrapper>
    )
}

export const query = graphql`
    query {
        mitoLogo: file(relativePath: { eq: "MitoLogo.png" }) {
            childImageSharp {
                # Specify the image processing specifications right in the query.
                # Makes it trivial to update as your page's design changes.
                fixed(width: 150, height: 27) {
                    ...GatsbyImageSharpFixed_noBase64
                }
            }
        }
    }
`

export default TopBar
